import React, { useEffect, useState } from 'react';
import ModuleFrame, { KV } from '../ModuleFrame';
import AskPane from '../AskPane';
import ConceptScreens from '../ConceptScreens';

// Lab › Try — talk to the app the way a visitor would (was App Builder's
// Preview tab): the same path as the website embed and the API, public
// documents only, the agent's own instructions and tools.

export default function Try({ org, app, studio, onPhase }) {
  const { attached, kLive, can } = studio;
  const [agentId, setAgentId] = useState(attached[0]?.id || '');
  useEffect(() => { if (!attached.find((a) => a.id === agentId)) setAgentId(attached[0]?.id || ''); }, [attached, agentId]);
  const agent = attached.find((a) => a.id === agentId) || null;
  return (
    <div className="lab-studio" data-nova-note={`Try phase for "${app.name}": talk to ${agent ? `agent "${agent.name}"` : 'an attached agent (none attached yet)'} the way a visitor would — public documents only (${kLive.length} live). NoVA: create_agent if none is attached; the conversation here is the person's.`}>
      <ConceptScreens org={org} appId={app.id} canRevise={can('lab.run')} onOpen={(screen, o) => onPhase('concept', null, { fig: 'screens', screen, revise: o?.revise ? 1 : null })} />
      <ModuleFrame.Columns cols={2}>
        <ModuleFrame.Panel
          title={agent ? `Talk to ${agent.name} as a visitor` : 'Try it'}
          meta={agent ? 'the same path as the website embed and API — public documents only' : 'no agent attached — asking the organization\'s knowledge as a member'}
          actions={attached.length > 1 ? (
            <select className="cs-input" value={agentId} onChange={(e) => setAgentId(e.target.value)} aria-label="Agent to try">
              {attached.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
            </select>
          ) : null}
        >
          {agent && agent.enabled === false && <p className="cs-form-error">This agent is disabled — enable it in Design.</p>}
          {agent?.greeting && <p className="ab-greet"><strong>{agent.name}.</strong> {agent.greeting}</p>}
          {agent ? <AskPane key={agent.id} orgId={org.id} agentToken={agent.publicToken} /> : <AskPane orgId={org.id} appId={app.id} />}
        </ModuleFrame.Panel>
        <ModuleFrame.Panel title="What the visitor gets" meta="why an answer looks the way it does">
          <KV rows={[
            ['Answers from', agent ? ((agent.knowledge?.mode || 'all') === 'all' ? 'all published documents' : agent.knowledge.mode === 'docs' ? `${(agent.knowledge.docIds || []).length} chosen documents` : `documents tagged ${(agent.knowledge.tags || []).join(', ')}`) : 'this app\'s published documents'],
            ['Audience', agent ? 'public documents only (visitors are anonymous)' : 'public + internal (you are a member)'],
            ['Live documents', `${kLive.length}`],
            ['Guardrails', org.guardrails && Object.values(org.guardrails).some(Boolean) ? 'on' : 'none set'],
            ['Can look up', agent ? ((agent.allowReads || []).join(', ') || 'nothing') : '—'],
          ]} />
        </ModuleFrame.Panel>
      </ModuleFrame.Columns>
    </div>
  );
}
